export default class Configuration {
  static preInvoiceConfig = new Configuration(false, true, 'preinvoice', process.env.VUE_APP_PREINVOICE_BACKEND_URL, process.env.VUE_APP_KEYCLOAK_PREINVOICES_RESOURCE, true);
  static invoiceConfig = new Configuration(true, false,'invoice', process.env.VUE_APP_INVOICE_BACKEND_URL, process.env.VUE_APP_KEYCLOAK_INVOICES_RESOURCE, false);

  constructor(createInvoiceButtonDisplayed, clientFieldDisabled, context, backendUrl, keycloakInvoicesResource, invoiceListDisplayModeSwitchDisplayed) {
    this.createInvoiceButtonDisplayed = createInvoiceButtonDisplayed;
    this.clientFieldDisabled = clientFieldDisabled;
    this.context = context;
    this.backendUrl = backendUrl;
    this.keycloakInvoicesResource = keycloakInvoicesResource;
    this.invoiceListDisplayModeSwitchDisplayed = invoiceListDisplayModeSwitchDisplayed;
  }

  static build(createInvoiceButtonDisplayed, clientFieldDisabled, context, backendUrl, keycloakInvoicesResource, invoiceListDisplayModeSwitchDisplayed) {
    return new Configuration(createInvoiceButtonDisplayed, clientFieldDisabled, context, backendUrl, keycloakInvoicesResource, invoiceListDisplayModeSwitchDisplayed);
  }

  static parse(value) {
    return value ? Configuration.build({
      createInvoiceButtonDisplayed: value.createInvoiceButtonDisplayed,
      clientFieldDisabled: value.clientFieldDisabled,
      context: value.context,
      backendUrl: value.backendUrl,
      keycloakInvoicesResource: value.keycloakInvoicesResource,
      invoiceListDisplayModeSwitchDisplayed: value.invoiceListDisplayModeSwitchDisplayed
    }) : null;
  }
}
